module.exports = __webpack_public_path__ + "static/media/06.112.ed7877ef.jpg";